module.exports = __webpack_public_path__ + "static/king-city-900ebf74b34a711d6a58d29f007ea3c7.jpg";